import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { Label } from "recharts";

const PlanningStockReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState();
  const [alert, setAlert] = useState(null);
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const [inputs, setInputs] = useState({});

  function getCurrentDate() {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // const fetchData = () => {
  //   Http.get("/report-leave-report").then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };

  useEffect(() => {
    DatatableFunc();
    // fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  // const formSubmit = () => {
  //   Http.get(
  //     "/movement-slip?from=" +
  //       inputs.from +
  //       "&to=" +
  //       inputs.to +
  //       "&staff=" +
  //       inputs.hr_staff_basic_info_id
  //   ).then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };

  const formSubmit = () => {
      Http.get(`/get-planning-stock-report?start_date=${inputs.start_date}&end_date=${inputs.end_date}`).then((res) => {
      if (res.data.data.length > 0) {
        setReceiveData(res.data.data[0].items);
      } else {
        setReceiveData([]);
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "No data found!",
        });
      }
    });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Planning Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-3"></div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-lg d-flex ">
                      {/* <select
                        className="form-control margin-bottom-on-mobile"
                        name="query_month"
                        value={inputs.query_month || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select Month</option>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select> */}
                      <div className="col-lg form-group me-1">
                        <label className="form-label">Start Date</label>
                        <input type="date" className="form-control" name="start_date" onChange={handleChange} />
                      </div>
                      <div className="col-lg form-group">
                        <label className="form-label">End Date</label>
                        <input type="date" className="form-control" name="end_date" onChange={handleChange} />
                      </div>
                    </div>

                    <div className="col-lg d-flex align-items-center mt-4">
                      <button
                        className="btn btn-primary btn-block mg-b-10"
                        onClick={formSubmit}
                      >
                        <i className="fa fa-send mg-r-10"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </div>
          {receiveData?.length > 0 && (
            <>
              <div className="am-pagebody">
                <div className="card pd-20 pd-sm-40">
                  {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
                  <div className="row">
                    <div className="col-12">
                      <div className="text-center">
                        <h5 className="text-uppercase text-sm font-weight-bolder">
                          Artisan Ceramics Limited
                        </h5>
                        <p>House-16, Road-07, Sector-01, Uttara, Dhaka</p>
                      </div>
                      <div className="table-responsive p-0 pb-2">
                        <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                          <thead>
                            <tr>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                S/N
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Product Name
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Shape
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Glaze Color
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Decoration
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Company
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Planning Qty
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Remaining Qty
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {receiveData?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.product.name}</td>
                                  <td>{item.shape.name}</td>
                                  <td>{item?.production_work_order_item?.color?.colour_name}</td>
                                  <td>{item.production_work_order_item?.decoration_name}</td>
                                  <td>{item.production_work_order.company.name}</td>
                                  <td>{item.qty}</td>
                                  <td>{item.remaining_qty}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanningStockReport;
